import { FIND_LOCATION_API_KEY } from "@/Constants/common";
import { serviceRouteConstants } from "@/Constants/routingConstants";

import { get, post, postFormData } from ".";
/**
 * Fetches the client profile data.
 *
 * @return {Promise} The client profile data.
 */
export const _fetchClientProfile = async () => {
  const request = {
    endPoint: serviceRouteConstants.profileData,
  };
  return await get(request);
};

export const _fetchClientContactProfile = async () => {
  const request = {
    endPoint: serviceRouteConstants.getContactProfileData,
  };
  return await get(request);
};

export const _updateClientContactProfile = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.updateClientContactData,
    data: data,
  };
  return await post(request);
};

/**
 * Get security code using the provided data.
 *
 * @param {Object} data - The data needed to get the security code
 * @return {Promise} The result of the post request for the security code
 */
export const _getSecurityCode = async (data) => {
  const request = {
    endPoint: serviceRouteConstants.getSecurityCode,
    data: data,
  };
  return await get(request);
};

/**
 * Fetches the address associated with the given postcode using the getAddress.io API.
 *
 * @param {string} postcode - The postcode for which to fetch the address.
 * @return {Promise<Object>} A promise that resolves with the address information.
 */
export const _fetchAddress = async (postcode) => {
  const request = {
    url: `https://api.getAddress.io/v2/uk/${postcode}?api-key=${FIND_LOCATION_API_KEY}`,
  };
};

/**
 * Updates the user's profile with the provided data.
 *
 * @param {object} data - The data to update the profile with
 * @return {Promise} The result of the profile update request
 */
export const _updateProfile = async (data) => {
  let clientName = data.clientName;
  let contactNumber = data.contactNumber;
  let practiceCode = data.practiceCode;
  let gender = data.gender;
  let email = data.email;
  let alternativeEmail = data.alternative_email;
  let facebook = data.facebook;
  let linkedIn = data.linked_in;
  let socialMediaLink = data.social_media_link;
  let address = data.address;
  let city = data.city;
  let postCode = data.postCode;
  let language = data.language;
  let referer = data.candidate_referel;
  let candidate_nationality = data.candidate_nationality;
  let candidate_date_of_birth = data.candidate_date_of_birth;
  let region = data.region;
  let county = data.county;
  let parking = data.parking;
  let website = data.website;
  let vat_number = data.vatNumber;

  let include_in_mailshot = data.include_in_mailshot;
  let include_in_vac_mailshot = data.include_in_vacancy_mailshot;
  let latitude = data.clientLat;
  let longitude = data.clientLon;

  let spokenLanguages = "[]";
  if (language && language.length) {
    spokenLanguages = JSON.stringify(language);
  }

  let alternativeEmailArray = "[]";
  if (alternativeEmail && alternativeEmail.length) {
    alternativeEmailArray = JSON.stringify(alternativeEmail);
  }

  let postData = {
    address: address,
    postcode: postCode,
    latitude: latitude,
    longitude: longitude,
    region: region,
    county: county,
    parking: parking,
    website: website,
    vat_number: vat_number,
    platform: "Web",
  };

  const request = {
    endPoint: serviceRouteConstants.updateProfileData,
    data: postData,
  };
  return await post(request);
};

/**
 * Updates the profile image using the provided data.
 *
 * @param {Object} data - The data for updating the profile image.
 * @return {Promise} The response from the post request.
 */
export const _updateProfileImage = async (data) => {
  let formData = new FormData();
  formData.append("client_profile", data.client_profile_image);

  return postFormData(serviceRouteConstants.updateProfileImage, formData);
};

export const _allowPublishJob = async (data) => {
  // client_allow_publish_job
  const request = {
    endPoint: serviceRouteConstants.clientAllowPublishJob,
    data: data,
  };
  return await post(request);
};
